import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { Checkbox } from 'components/common/checkbox';
import { Collapsible } from 'components/common/collapsible';
import { Input } from 'components/common/input';
import { ReviewScoreFilter } from 'components/reviewScoreFilter';
import { COMPARISON_OPERATORS, filter } from 'lib';
import {
    setFilteredProperties,
    // getBookingWidgetMultipropertyData,
} from 'features/multiproperty/MultipropertySlice';

const MultipropertyFilters = () => {
    const dispatch = useDispatch();
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);

    // const multipropertyUrl = useSelector(
    //     (state) => state.miniBookingWidget?.data?.multipropertyUrl
    // );

    const multipropertyPropeties =
        useSelector((state) => state.multiproperty.multipropertyProperties) ||
        [];

    const multipropertyScoreFilter =
        useSelector(
            (state) => state.miniBookingWidget?.data?.multipropertyScoreFilter
        ) || [];

    const [filters, setFilters] = useState([
        {
            name: 'hasBreakfast',
            value: false,
            fieldsToCheckAgainst: ['hasBreakfast'],
        },
        {
            name: 'hasMemberPrice',
            value: false,
            fieldsToCheckAgainst: ['hasMemberPrice'],
        },
        { name: 'hasWifi', value: false, fieldsToCheckAgainst: ['hasWifi'] },
        {
            name: 'reviewsScore',
            value: 0,
            fieldsToCheckAgainst: ['totalScoreDecimal'],
            comparisonOperator: COMPARISON_OPERATORS.gte,
        },
        {
            name: 'searchInput',
            value: '',
            fieldsToCheckAgainst: ['propertyName', 'ariaLocation'],
        },
    ]);

    // const sortByProperty = useSelector((state) => state.user?.sortByProperty);

    // useEffect(() => {
    //     if (multipropertyUrl) {
    //         dispatch(
    //             getBookingWidgetMultipropertyData({
    //                 multipropertyUrl,
    //                 sortByProperty,
    //                 filters,
    //             })
    //         );
    //     }
    // }, [multipropertyUrl]);

    const [selectedReviewScoreIndex, setSelectedReviewScoreIndex] = useState(0);

    const handleFillterChange = (filterName, value) => {
        const updatedFilters = filters.map((filter) => {
            if (filter.name === filterName) {
                filter.value = value;
            }

            return filter;
        });

        setFilters(updatedFilters);

        const hasActiveFilters = updatedFilters.some((filter) => {
            return filter.value;
        });

        if (hasActiveFilters) {
            const matchingProperties = filter(
                multipropertyPropeties,
                updatedFilters
            );
            dispatch(
                setFilteredProperties({
                    filteredProperties: matchingProperties,
                })
            );
        } else {
            dispatch(
                setFilteredProperties({
                    filteredProperties: multipropertyPropeties,
                })
            );
        }
    };
    return (
        <div className="ab-multiproperty-filters-main">
            <div className="ab-body-sidebar-section">
                <Collapsible title={Lang?.searchByPropertyName} open>
                    <div className="ab-multiproperty-search-properties">
                        <Input
                            onChange={(event) => {
                                handleFillterChange(
                                    'searchInput',
                                    event.target.value
                                );
                            }}
                            placeholder={Lang?.typeAPropertyNameOrArea}
                            id="search"
                        />
                    </div>
                </Collapsible>
            </div>

            <div className="ab-body-sidebar-section">
                <Collapsible title={Lang?.suggestiveFilters} open>
                    <Checkbox
                        className="ab-multiproperty-filter"
                        isChecked={
                            filters.find((filter) => {
                                return filter.name === 'hasBreakfast';
                            })?.value
                        }
                        onChange={(event) =>
                            handleFillterChange(
                                'hasBreakfast',
                                event.target.checked
                            )
                        }
                    >
                        {Lang?.breakfastText}
                    </Checkbox>
                    <Checkbox
                        className="ab-multiproperty-filter"
                        isChecked={
                            filters.find((filter) => {
                                return filter.name === 'hasWifi';
                            })?.value
                        }
                        onChange={(event) =>
                            handleFillterChange('hasWifi', event.target.checked)
                        }
                    >
                        {Lang?.freeWifi}
                    </Checkbox>
                </Collapsible>
            </div>

            <div className="ab-body-sidebar-section">
                <Collapsible title={Lang?.exclusiveOffers} open>
                    <Checkbox
                        className="ab-multiproperty-filter"
                        isChecked={
                            filters.find((filter) => {
                                return filter.name === 'hasMemberPrice';
                            })?.value
                        }
                        onChange={(event) =>
                            handleFillterChange(
                                'hasMemberPrice',
                                event.target.checked
                            )
                        }
                    >
                        {Lang?.memberPrices}
                    </Checkbox>
                </Collapsible>
            </div>

            <div className="ab-body-sidebar-section">
                <Collapsible title={Lang?.reviewScore} open>
                    <div className="ab-review-score-filter">
                        {multipropertyScoreFilter.map((property, index) => {
                            return (
                                <ReviewScoreFilter
                                    key={index}
                                    menuItems={property}
                                    selected={
                                        selectedReviewScoreIndex === index
                                    }
                                    onClick={() => {
                                        setSelectedReviewScoreIndex(index);
                                        handleFillterChange(
                                            'reviewsScore',
                                            property.value
                                        );
                                    }}
                                />
                            );
                        })}
                    </div>
                </Collapsible>
            </div>
        </div>
    );
};

export default MultipropertyFilters;
